import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MicExternalOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mic_external_on"}/>
}
